import React, { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import blogsData from "./BlogData";

const Blog = () => {
     useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);
  return (
   <div >
     
<section
  className="section mt-5 contact-hero"
  style={{
    backgroundImage: `url('/assets/img/about-bg.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    padding: '60px 0',
    position: 'relative',
    color: '#fff',
    textAlign: 'center',
  }}
>
  {/* Overlay for fade effect */}
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)', // fade effect
      zIndex: 1,
    }}
  ></div>

  <div className="container" style={{ position: 'relative', zIndex: 2 }}>
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <nav className="custom-breadcrumbs mb-3">
          <a href="/">Home</a>
          <span className="separator">/</span>
          <a href="/blog">Blog</a> 
        </nav>
        <h1 style={{color:'#c5c5c5'}} className="display-4 fw-bold">Blogs</h1>
        <p className="lead mt-3">
          Reach out to us for web development services, inquiries, or support.
        </p>
      </div>
    </div>
  </div>
</section>


    {/* Blog Section */}

   <section id="blog" className=" mt-5 blog section">
  {/* Section Title */}
  <div className="container section-title" data-aos="fade-up">
    <h2>Insight Corner</h2>
    <p>A curated selection of our latest blogs and thought-leadership pieces that explores the Bojotech diference</p>
  </div>

  <div className="container">
   
     <div className="row g-4">
          {blogsData.map((blog, index) => (
            <div
              key={blog.id}
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay={100 * (index + 1)}
            >
              <div className="blog-card shadow-sm rounded">
                <img
                  src={blog.image}
                  className="img-fluid rounded-top"
                  alt={blog.title}
                />
                <div className="blog-content p-4">
                  <h5>{blog.title}</h5>
                  <p>{blog.shortDesc}</p>
                  <Link to={`/blog/${blog.slug}`} className="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
  </div>
</section>

    {/* /Blog Section */}
   

</div>

  )
}

export default Blog;

